/**
 * Builds a cookie header string from a plain key-value cookies object.
 * This is a pure utility — safe to use in both server and client contexts.
 */
export const buildCookieHeader = (cookies: { [key: string]: string }) =>
  Object.entries(cookies || {}).reduce(
    (acc, [key, val]) => acc + `${key}=${encodeURIComponent(val)};`,
    ''
  )
